/* Lucebox Zero 495 configurator: options, live total, shareable URL, checkout. No dependencies.
   Data comes from the JSON block the section renders (sections/lb-configure.liquid). */
(function () {
  'use strict';

  var DEFAULTS = { memory: '128', storage: '2tb', cluster: '0', qty: 1 };
  var VALID = { memory: ['128', '192'], storage: ['2tb', '4tb'], cluster: ['0', '1'] };
  var LABELS = { memory: { '128': '128 GB', '192': '192 GB' }, storage: { '2tb': '2 TB', '4tb': '4 TB' } };

  /* $6,499 in every currency: English grouping, cents only when there are any (like lb-money). */
  function money(cents, symbol) {
    var whole = Math.floor(Math.abs(cents) / 100);
    var rest = Math.abs(cents) % 100;
    var grouped = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var text = symbol + grouped + (rest ? '.' + String(rest).padStart(2, '0') : '');
    return cents < 0 ? '-' + text : text;
  }

  function readData(root) {
    var node = document.querySelector('[data-lb-cfg-data]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  function initConfigurator(root) {
    var data = readData(root);
    if (!data || !data.variants || !data.variants.length) return;

    var live = data.mode === 'live';
    var symbol = data.symbol || '$';
    var form = root.querySelector('#lb-cfg-form');
    var qtyInput = root.querySelector('[data-lb-cfg-quantity]');
    var qtyButtons = root.querySelectorAll('[data-lb-cfg-qty]');
    var teamHint = root.querySelector('[data-lb-cfg-team-hint]');
    var kitLine = root.querySelector('[data-lb-cfg-kit-line]');
    var kitSub = root.querySelector('[data-lb-cfg-kit-sub]');
    var machineSub = root.querySelector('[data-lb-cfg-machine-sub]');
    var total = root.querySelector('[data-lb-cfg-total]');
    var payButton = root.querySelector('[data-lb-cfg-pay]');
    var baseLabel = (payButton && payButton.getAttribute('data-label')) || 'Order now';
    var variantInput = root.querySelector('[data-lb-cfg-variant]');
    var wallets = root.querySelector('[data-lb-cfg-wallets]');
    var terms = root.querySelector('[data-lb-cfg-terms]');
    var status = root.querySelector('[data-lb-cfg-status]');
    var dockTotal = root.querySelector('[data-lb-cfg-dock-total]');
    var headPrice = root.querySelector('[data-lb-cfg-price]');
    var headList = root.querySelector('[data-lb-cfg-list]');
    var headLabel = root.querySelector('[data-lb-cfg-start-label]');
    var shipLine = root.querySelector('[data-lb-cfg-ship]');
    var info = initInfo(root);
    var lastCluster = null;
    var discount = Number(data.discount) || 0;
    var maxQty = Number(data.maxQty) || 5;

    var state = { memory: DEFAULTS.memory, storage: DEFAULTS.storage, cluster: DEFAULTS.cluster, qty: DEFAULTS.qty };

    function variantFor(memory, storage) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        if (v.memory === memory && v.storage === storage) return v;
      }
      return null;
    }

    function hasKit() { return !!data.kit && state.cluster === '1'; }

    /* "+$2,000" next to an option, priced against what else is chosen, so the sum always adds up. */
    function updateDeltas() {
      var m128 = variantFor('128', state.storage);
      var m192 = variantFor('192', state.storage);
      var s2 = variantFor(state.memory, '2tb');
      var s4 = variantFor(state.memory, '4tb');
      var deltas = {
        'memory:192': m128 && m192 ? m192.price - m128.price : null,
        'storage:4tb': s2 && s4 ? s4.price - s2.price : null,
        'cluster:1': data.kit ? data.kit.price : null
      };
      Object.keys(deltas).forEach(function (key) {
        var node = root.querySelector('[data-lb-cfg-delta="' + key + '"]');
        if (!node || deltas[key] === null) return;
        /* The kit keeps its "/ machine" tail: only the amount is rewritten. */
        var amount = node.firstChild && node.firstChild.nodeType === 3 ? node.firstChild : null;
        var text = '+' + money(deltas[key], symbol);
        if (amount) amount.nodeValue = text;
        else node.insertBefore(document.createTextNode(text), node.firstChild);
      });
    }

    function writeUrl() {
      if (!window.history || !window.history.replaceState || !window.URL) return;
      var url = new URL(window.location.href);
      ['memory', 'storage', 'cluster'].forEach(function (key) {
        if (state[key] === DEFAULTS[key]) url.searchParams.delete(key);
        else url.searchParams.set(key, state[key]);
      });
      if (state.qty !== DEFAULTS.qty) url.searchParams.set('qty', String(state.qty));
      else url.searchParams.delete('qty');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }

    function render() {
      var variant = variantFor(state.memory, state.storage);
      if (!variant) return;
      var kit = hasKit();
      var machines = variant.price * state.qty;
      /* One kit per machine (2026-10-01). */
      var kits = kit ? data.kit.price * state.qty : 0;
      var sum = machines + kits;
      var available = variant.available !== false && (!kit || data.kit.available !== false);

      if (machineSub) {
        machineSub.textContent = LABELS.memory[state.memory] + ' · ' + LABELS.storage[state.storage] + ' · ' + state.qty + ' × ' + money(variant.price, symbol);
      }
      if (kitLine) kitLine.hidden = !kit;
      if (kit && kitSub) kitSub.textContent = 'Cluster kit · ' + state.qty + ' × ' + money(data.kit.price, symbol);
      if (total) total.textContent = money(sum, symbol);
      if (dockTotal) dockTotal.textContent = money(sum, symbol);
      /* The head price is one machine as configured, kit included; the list price is that plus
         the launch discount. "Starting at" only while nothing is added. */
      var unit = variant.price + (kit ? data.kit.price : 0);
      if (headPrice) headPrice.textContent = money(unit, symbol);
      if (headList) headList.textContent = money(unit + discount, symbol);
      if (headLabel) {
        var base = !kit && state.memory === DEFAULTS.memory && state.storage === DEFAULTS.storage;
        headLabel.textContent = headLabel.getAttribute(base ? 'data-base' : 'data-custom');
      }
      /* 192 GB machines ship a month later (2026-10-12), so the line under the button follows the memory. */
      if (shipLine) shipLine.textContent = shipLine.getAttribute(state.memory === '192' ? 'data-192' : 'data-base');
      /* Choosing the kit opens its note, going back to no kit folds it. */
      if (info && state.cluster !== lastCluster) {
        info.pin(kit);
        lastCluster = state.cluster;
      }

      if (payButton) {
        payButton.disabled = !available;
        /* After a valid VAT number the EU app owns the label (lucebox-vat.js paints it). */
        var payLabel = payLabelEl();
        if (payLabel && payButton.getAttribute('data-b2b-enabled') !== 'true') {
          payLabel.textContent = available ? baseLabel + ' · ' + money(sum, symbol) : 'Sold out';
        }
      }
      if (variantInput && variant.id && variantInput.value !== String(variant.id)) {
        variantInput.value = variant.id;
        /* Shopify's installments banner and wallets follow the form's id input through this event. */
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      /* Shop Pay, the other wallets and the installments banner see only the form's machine, so
         they show for the base configuration alone; upgrades and the kit go through Order now. */
      var baseOnly = !kit && (!variant.items || variant.items.length === 1);
      if (wallets) wallets.hidden = !baseOnly;
      if (terms) terms.hidden = !baseOnly;

      if (qtyInput) qtyInput.value = String(state.qty);
      /* Two machines or more: point the team buyer at Business (Sandro, 2026-10-21). */
      if (teamHint) teamHint.hidden = state.qty < 2;
      qtyButtons.forEach(function (button) {
        var step = Number(button.getAttribute('data-lb-cfg-qty'));
        button.disabled = (step < 0 && state.qty <= 1) || (step > 0 && state.qty >= capFor());
      });
      root.classList.toggle('is-cluster', kit);

      updateDeltas();
      if (status && status.getAttribute('data-kind') === 'preview') clearStatus();
      writeUrl();
      /* What the cart must hold for this configuration, for lucebox-vat.js. */
      if (live) root.setAttribute('data-lb-cfg-items', JSON.stringify(cartItems()));
      root.dispatchEvent(new CustomEvent('lb-cfg:change'));
    }

    function setStatus(text, kind) {
      if (!status) return;
      status.textContent = text;
      status.setAttribute('data-kind', kind);
    }
    function clearStatus() {
      if (!status) return;
      status.textContent = '';
      status.removeAttribute('data-kind');
    }

    function setCluster(value) {
      state.cluster = value;
    }

    /* The most machines this configuration can take: the order cap, or less when the
       machine or an upgrade (the 192 GB stock) has fewer left. */
    function capFor() {
      var variant = variantFor(state.memory, state.storage);
      return variant && variant.max ? Math.min(maxQty, variant.max) : maxQty;
    }

    function setQty(next) {
      var n = Math.round(Number(next));
      if (!isFinite(n)) n = 1;
      state.qty = Math.min(capFor(), Math.max(1, n));
    }

    function check(group, value) {
      var input = root.querySelector('input[name="lb-cfg-' + group + '"][value="' + value + '"]');
      if (input) input.checked = true;
    }

    /* Deep link: ?memory=192&storage=4tb&cluster=1&qty=3, so lucebox.com can open a configuration. */
    function readUrl() {
      var params = new URLSearchParams(window.location.search);
      var memory = (params.get('memory') || '').toLowerCase().replace(/\s|gb/g, '');
      var storage = (params.get('storage') || '').toLowerCase().replace(/\s/g, '');
      var cluster = (params.get('cluster') || '').toLowerCase();
      if (cluster === 'true' || cluster === 'yes') cluster = '1';
      if (cluster === 'false' || cluster === 'no') cluster = '0';
      if (VALID.memory.indexOf(memory) > -1) state.memory = memory;
      if (VALID.storage.indexOf(storage) > -1) state.storage = storage;
      if (params.has('qty')) setQty(params.get('qty'));
      if (data.kit && VALID.cluster.indexOf(cluster) > -1) setCluster(cluster);
      check('memory', state.memory);
      check('storage', state.storage);
      check('cluster', state.cluster);
    }

    root.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.name) return;
      if (input.name === 'lb-cfg-memory') { state.memory = input.value; setQty(state.qty); }
      else if (input.name === 'lb-cfg-storage') state.storage = input.value;
      else if (input.name === 'lb-cfg-cluster') setCluster(input.value);
      else if (input === qtyInput) setQty(input.value);
      else return;
      render();
    });

    qtyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setQty(state.qty + Number(button.getAttribute('data-lb-cfg-qty')));
        render();
      });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!live) {
          setStatus(status ? status.getAttribute('data-preview') : '', 'preview');
          return;
        }
        order();
      });
    }

    function payLabelEl() {
      return payButton ? payButton.querySelector('[data-lb-cfg-pay-label]') : null;
    }

    /* The cart lines for what is configured. Each upgrade and the kit at the machine's
       quantity, the machine last: Shopify lists the newest line first, so the machine heads
       checkout. Its line carries the configuration, so checkout, the order and the packing
       slip all show it. */
    function cartItems() {
      var variant = variantFor(state.memory, state.storage);
      if (!variant || !variant.id) return [];
      var ids = variant.items && variant.items.length ? variant.items : [variant.id];
      var machine = { id: ids[0], quantity: state.qty, properties: { Memory: LABELS.memory[state.memory], Storage: LABELS.storage[state.storage], 'Cluster kit': hasKit() ? 'Yes' : 'No' } };
      var items = ids.slice(1).map(function (id) { return { id: id, quantity: state.qty }; });
      if (hasKit() && data.kit.id) items.push({ id: data.kit.id, quantity: state.qty });
      items.push(machine);
      return items;
    }

    /* Empty the cart, add exactly the configuration, go to checkout. Clicking twice cannot
       stack up a second order, the same rule as the Founder Edition buy button. */
    function order() {
      var items = cartItems();
      if (!items.length || !payButton) return;

      payButton.disabled = true;
      var payLabel = payLabelEl();
      if (payLabel) payLabel.textContent = 'One moment';
      clearStatus();

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function (cleared) {
          /* Never add on top of an old cart: stop if it could not be emptied. */
          if (!cleared.ok) throw new Error('clear failed');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (response) {
          if (response.ok) {
            window.location.href = '/checkout';
            return null;
          }
          /* 422: not enough stock for this quantity. Shopify's description says how many are left. */
          return response.json().then(function (body) {
            var error = new Error('add failed');
            error.stock = response.status === 422 ? (body && (body.description || body.message)) : null;
            throw error;
          }, function () { throw new Error('add failed'); });
        })
        .catch(function (error) {
          payButton.disabled = false;
          render();
          if (error && error.stock) setStatus(error.stock + ' Lower the quantity, or write to us and we will sort it out.', 'error');
          else setStatus('Something went wrong reaching checkout. Try again, or write to us and we will sort it out.', 'error');
        });
    }

    /* lucebox-vat.js asks for a repaint when the EU app hands the buy button back. */
    root.addEventListener('lb-cfg:refresh', render);

    readUrl();
    render();
    initDock(root, payButton, form);
    initHeaderOrder(root, payButton, form);
    initVat(root);

    /* Safari keeps the page in its back-forward cache: coming back from checkout must not leave
       the button on "One moment". */
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted || !payButton) return;
      payButton.disabled = false;
      render();
    });
  }

  /* The cluster kit note: a click pins it open or shut, a mouse over it opens it until the
     mouse leaves, unless a click or the kit choice pinned it. */
  function initInfo(root) {
    var info = root.querySelector('[data-lb-cfg-info]');
    var summary = info && info.querySelector('summary');
    if (!info || !summary) return null;
    var hover = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
    var pinned = false;

    function canHover() { return !!(hover && hover.matches); }
    function pin(open) {
      pinned = open;
      info.open = open;
    }

    info.addEventListener('mouseenter', function () { if (canHover()) info.open = true; });
    info.addEventListener('mouseleave', function () { if (canHover() && !pinned) info.open = false; });
    summary.addEventListener('click', function (event) {
      event.preventDefault();
      pin(!(info.open && pinned));
    });
    return { pin: pin };
  }

  /* Phones: the dock carries the live total while the real button is off screen. */
  function initDock(root, payButton, form) {
    var dock = root.querySelector('[data-lb-cfg-dock]');
    var dockButton = root.querySelector('[data-lb-cfg-dock-btn]');
    if (!dock || !dockButton || !payButton || !window.IntersectionObserver || !window.matchMedia) return;

    var phone = window.matchMedia('(max-width: 720px)');
    var payVisible = true;

    function cookieBannerUp() {
      var banner = document.getElementById('shopify-pc__banner');
      /* position: fixed, so offsetParent is always null; ask for its boxes instead. */
      return !!(banner && banner.getClientRects().length > 0 && getComputedStyle(banner).display !== 'none');
    }

    function update() {
      var show = phone.matches && !payVisible && !payButton.disabled && !cookieBannerUp();
      dock.hidden = !show;
      document.documentElement.classList.toggle('lb-dock-on', show);
    }

    new IntersectionObserver(function (entries) {
      payVisible = entries[0].isIntersecting;
      update();
    }).observe(payButton);

    /* Live: the dock orders at once. Preview: it brings the button and its note into view first. */
    dockButton.addEventListener('click', function () {
      if (root.getAttribute('data-mode') !== 'live') {
        var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        payButton.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
      }
      if (form && typeof form.requestSubmit === 'function') form.requestSubmit(payButton);
      else payButton.click();
    });
    root.addEventListener('lb-cfg:change', update);
    document.addEventListener('visitorConsentCollected', function () { setTimeout(update, 50); });
    window.addEventListener('scroll', update, { passive: true });
    if (phone.addEventListener) phone.addEventListener('change', update);
    update();
  }

  /* The header's Order now orders what is configured right now (the base machine when nothing
     was touched), exactly like the button under the summary. Without this it was a link to "/",
     which reloaded the page and dropped the configuration. */
  function initHeaderOrder(root, payButton, form) {
    var links = document.querySelectorAll('[data-lb-order]');
    if (!links.length || !payButton || !form) return;

    function bringButtonIntoView() {
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      payButton.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        /* Sold out, or an order already on its way: show the button and its state instead. */
        if (payButton.disabled) {
          bringButtonIntoView();
          return;
        }
        if (root.getAttribute('data-mode') !== 'live') bringButtonIntoView();
        if (typeof form.requestSubmit === 'function') form.requestSubmit(payButton);
        else payButton.click();
      });
    });
  }

  /* Order without VAT (2026-10-03): the link under the buy button opens a request form that
     carries the configuration on screen. Without JavaScript the link is a plain email.
     Shopify guards its contact form with hCaptcha, whose challenge sits on the page at a huge
     z-index: a modal dialog (top layer) would cover it and trap the buyer, so the dialog opens
     non-modal over its own scrim and handles Escape, focus and page scroll itself. */
  function initVat(root) {
    var dialog = root.querySelector('[data-lb-vat]');
    if (!dialog || typeof dialog.show !== 'function') return;
    var opener = root.querySelector('[data-lb-vat-open]');
    var summary = dialog.querySelector('[data-lb-vat-summary]');
    var field = dialog.querySelector('[data-lb-vat-config]');

    function text(selector) {
      var node = root.querySelector(selector);
      return node && !node.hidden ? node.textContent.trim() : '';
    }

    function fill() {
      var lines = [text('[data-lb-cfg-machine-sub]'), text('[data-lb-cfg-kit-sub]')].filter(Boolean);
      var total = text('[data-lb-cfg-total]');
      if (total) lines.push('Total ' + total + ' with VAT');
      if (summary) summary.textContent = lines.join('\n');
      /* The link reopens the same configuration for whoever answers the request. */
      if (field) field.value = lines.join(' | ') + ' | ' + window.location.href;
    }

    var returnFocus = null;

    function open() {
      fill();
      returnFocus = document.activeElement;
      dialog.show();
      document.documentElement.classList.add('lb-vat-on');
      var first = dialog.querySelector('[data-lb-vat-result], input:not([type=hidden])');
      if (first) {
        if (!first.matches('input')) first.setAttribute('tabindex', '-1');
        first.focus();
      }
    }

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('lb-vat-on');
      if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
    });
    if (opener) {
      opener.addEventListener('click', function (event) {
        event.preventDefault();
        open();
      });
    }
    dialog.addEventListener('click', function (event) {
      /* The dialog is the scrim; a click on it, outside the form, closes. */
      if (event.target === dialog || event.target.closest('[data-lb-vat-close]')) dialog.close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && dialog.open) dialog.close();
    });
    root.addEventListener('lb-cfg:change', function () { if (dialog.open) fill(); });

    /* Back from Shopify's contact form: show what happened, then drop the flag from the URL so
       a reload does not show it again. */
    if (dialog.querySelector('[data-lb-vat-result]')) {
      open();
      if (window.URL && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.delete('contact_posted');
        window.history.replaceState(window.history.state, '', url.pathname + url.search);
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-lb-cfg]').forEach(initConfigurator);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
